import { useVehicleCount } from '@cinch-nx/data-search'
import { FullWidthCTA } from '@cinch-nx/landing-ui-shared/lib/shared/full-width-cta/full-width-cta'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared/lib/storyblok-renderer/storyblok-renderer'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { useRouter } from 'next/router'

import { storyblokComponents } from './data/storyblok-renderer-map'
import styles from './seo-page.module.css'
import { SEOPageStoryContent } from './types/seo-page'

export interface SEOPageFeatureProps {
  children?: React.ReactNode
  content: SEOPageStoryContent
}

export const SEOPageFeature: React.FC<SEOPageFeatureProps> = ({ content }) => {
  const { vehicleCount } = useVehicleCount()
  const router = useRouter()
  const numberOfCars = new Intl.NumberFormat('en-GB').format(vehicleCount ?? 0)
  const { trackEvent } = useAnalytics()
  const handleClick = () => {
    trackEvent({
      eventName: `Abandoned Landing page - click search all cars button`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'button',
          label: 'browse all cars',
          action: 'footer',
        },
      },
    })
    router.push('/find-vehicle')
  }

  if (!content) return null

  const limitedItems: { [key: string]: number } = { FaqSection: 1 }

  const wrappedComponents = content.body
    .map((el) => el.component)
    .filter((el) => el !== 'FeatureSection')

  return (
    <article className={styles.mainSection} data-testid="seo-page">
      <StoryblokRenderer
        block={content.body}
        limitedItems={limitedItems}
        componentsWithWrapper={wrappedComponents}
        components={storyblokComponents}
      />
      <FullWidthCTA
        iconName="search"
        iconGradient="galaxy"
        iconSize={41}
        title="Let’s find your next car"
        subtitle="Ready to hit the open road?"
        buttonLabel={`Search all ${numberOfCars} cars`}
        className={styles.cta}
        onButtonClick={handleClick}
        img={{
          src: 'https://a.storyblok.com/f/132543/1054x407/a30d43e649/about-us-civic.png/m/871x0',
          alt: 'Side view of a Honda Civic',
          width: 871,
          height: 336,
        }}
      />
    </article>
  )
}
